export default class MenuPopupSub {
  classButton = 'menu-popup-menu__button'
  classItem = 'menu-popup-menu__item'
  classItemOpen = 'menu-popup-menu__item-open'

  constructor () {
    let self = this

    $(`.${self.classButton}`).click(function () {
      $(this).closest(`.${self.classItem}`).toggleClass(self.classItemOpen)
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Menu/MenuPopupSub.js